export default __webpack_public_path__ + "static/media/gerpal4.728b8227.jpg";